import styled from 'styled-components'

export const Container = styled.div`
  margin-top: 4.5rem;
  width: 100%;
`
